export const donor = state => state.donors.donors